import styled from 'styled-components';
import classNames from 'classnames';
import useMediaQuery from '@/hooks/useMediaQuery';
import { getComponentMargin, getAnchorId } from '@/utils/builderUtils';
import StaticRingSizeTable from './StaticRingSizeTable';
import StaticPinnedColumns from './StaticPinnedColumns';

const Container = styled.div`
  table {
    background-color: transparent;
    border-collapse: collapse;
    border-spacing: 0;
  }
  td,
  th {
    border: 1px solid #d4d4d4;
    padding: 9px 10px;
    text-align: center;
  }
  th {
    font-weight: bold;
  }
  p {
    letter-spacing: 0.025em;
  }
  .table-wrapper {
    position: relative;
    overflow: hidden;
    border-right: 1px solid #ccc;
  }
  .scrollable {
    overflow: scroll;
    overflow-y: hidden;
  }
  @media (max-width: 767px) {
    .responsive {
      margin-bottom: 0;
    }
    .pinned {
      position: absolute;
      left: 0;
      top: 0;
      background: #fff;
    }
    .pinned-table-header {
      display: block;
      width: 154px;
      white-space: normal;
    }
    .large-table-header {
      display: block;
      width: 200px;
      white-space: normal;
    }
    .medium-table-header {
      display: block;
      width: 120px;
      white-space: normal;
    }
  }
`;

interface RingSizeTableProps {
  /**
   * Turn on to add margin to the bottom of the component
   */
  margin?: boolean;
  /**
   * Give to the component an anchor link id
   */
  anchorLinkID?: string;
}

export default function RingSizeTable({ margin = false, anchorLinkID }: RingSizeTableProps) {
  const isAboveDesktop = useMediaQuery('(min-width: 768px)');
  return (
    <Container
      {...getAnchorId(anchorLinkID)}
      className={classNames(
        'tw-container tw-text-center tw-mx-auto tw-font-base tw-text-be-sm min-[1130px]:tw-max-w-[1130px] tw-px-6',
        getComponentMargin(margin)
      )}
    >
      <div className="tw-visible desktop:tw-invisible tw-mb-2">
        <div className="tw-container">
          <p className="tw-mb-0 tw-mt-be-2 tw-text-be-light-gray tw-text-be-sm">Swipe to view more countries</p>
        </div>
      </div>
      {isAboveDesktop && <StaticRingSizeTable />}
      {!isAboveDesktop && (
        <div className="table-wrapper">
          <div className="scrollable">
            <StaticRingSizeTable />
          </div>
          <div className="pinned">
            <StaticPinnedColumns />
          </div>
        </div>
      )}
    </Container>
  );
}
